/* global Stripe */
import { Controller } from "@hotwired/stimulus"
import config from "@app/config"

let stripe;

try {
  stripe = Stripe(config.stripePublicKey)
} catch(_e) {
  console.log("Stripe is not defined");
}

export default class extends Controller {
  static targets = [
    "paymentIntentInfo", "cardPaymentElement", "auBankAccountElement",
    "debitName", "cardName", "email", "paymentMessage", "submitButton",
    "successfulMessage", "formContainer", "paymentDetails"
  ]

  async connect() {
    if (stripe !== undefined) {
      const style = {
        base: {
          fontSize: "18px",
          fontFamily: "Open Sans, sans-serif",
          fontWeight: 300,
          "::placeholder": {
            backgroundColor: "#fff",
          },
        },
      }

      const options = {
        style,
        disabled: false,
        hideIcon: false,
        iconStyle: "default",
      }
      const elements = stripe.elements()
      if (this.hasCardPaymentElementTarget) {
        this.card = elements.create("card", options)
        this.card.mount(this.cardPaymentElementTarget)
        this.card.on("change", this.handleChange.bind(this))
      } else if (this.hasAuBankAccountElementTarget) {
        this.auBankAccount = elements.create("auBankAccount", options)
        this.auBankAccount.mount(this.auBankAccountElementTarget)
        this.auBankAccount.on("change", this.handleChange.bind(this))
      }
    }
  }

  async handleSubmit(e) {
    e.preventDefault()
    this.submitButtonTarget.disabled = true

    // open loading modal
    const loadingModal = document.querySelector("#modal-loading")
    loadingModal.querySelector("#loading-modal-title").textContent = "We're updating your payment details..."
    loadingModal.querySelector("#loading-modal-message").textContent = "Your new payment will be used when your next payment is due"

    const clientSecret = this.paymentIntentInfoTarget.dataset.clientSecret
    const returnUrl = this.formContainerTarget.dataset.url

    let name = ""

    if (this.hasDebitNameTarget) {
      name = this.debitNameTarget.value
    } else if (this.hasCardNameTarget) {
      name = this.cardNameTarget.value
    }

    const { error } = await (this.hasAuBankAccountElementTarget
      ? stripe.confirmAuBecsDebitSetup(clientSecret, {
        payment_method: {
          au_becs_debit: this.auBankAccount,
          billing_details: {
            name: name,
            email: this.emailTarget.value,
          },
        },
        return_url: returnUrl,
      })
      : stripe.confirmCardSetup(clientSecret, {
        payment_method: {
          card: this.card,
          billing_details: {
            name: name,
          },
        },
        return_url: returnUrl,
      }))

    this.submitButtonTarget.disabled = false
    if (error) {
      this.showMessage(error.message)
    } else {
      window.HSOverlay.open("#modal-loading")
      setTimeout(() => {
        window.location.href = returnUrl
      }, 4000)
    }
  }

  handleChange(e) {
    if (e.complete) {
      this.paymentMessageTarget.classList.add("hidden")
      this.submitButtonTarget.disabled = false
    } else if (e.error) {
      this.showMessage(e.error.message)
      this.submitButtonTarget.disabled = true
    }
  }

  showMessage(messageText) {
    this.paymentMessageTarget.classList.remove("hidden")
    this.paymentMessageTarget.textContent = messageText
  }
}
